import { getClient } from '@zg-rentals/ts-client-http-client';

/**
 * Creates a configured HTTP client for making API requests to the Zillow Group API.
 * This client can be customized on a per-hook basis by passing options.
 *
 * @param options - Optional configuration options
 * @param options.timeout - Custom timeout in milliseconds for requests
 *
 * @example
 * // Create a client with a custom timeout for photo uploads
 * const { mutateAsync: uploadPhoto } = useUploadPhoto({
 *   httpClient: createZgApiHttpClient().extend({ timeout: 3 * 60 * 1000 })
 * });
 *
 * @example
 * // Create a default client without custom options
 * const { mutateAsync: fetchData } = useFetchData({
 *   httpClient: createZgApiHttpClient()
 * });
 */
export const createZgApiHttpClient = (prefixUrl: string) =>
  getClient().extend({
    prefixUrl,
    headers: {
      'x-build-id': String(process.env.NEXT_PUBLIC_BUILD_NUMBER),
    },
  });
